import { useUpdateEffect } from 'react-use'
import {
  DESKTOP,
  DESKTOP_LARGE,
  DESKTOP_LARGE_X,
  TABLET,
  TABLET_SMALL,
  useBreakpoint,
} from 'masterplan-shared'

export default function useEffectOnBreakpoint(effect: () => void) {
  useBreakpoint({ breakpoint: TABLET_SMALL })
  useBreakpoint({ breakpoint: TABLET })
  useBreakpoint({ breakpoint: DESKTOP })
  useBreakpoint({ breakpoint: DESKTOP_LARGE })
  useBreakpoint({ breakpoint: DESKTOP_LARGE_X })

  useUpdateEffect(effect)
}
